export enum HublerNetworkApplicationState {
  INVITED = 'INVITED',
  NOT_STARTED = 'NOT_STARTED',
  WORKING_INSTITUTIONS = 'WORKING_INSTITUTIONS',
  HUBLER_EMPLOYMENT_STATUS = 'HUBLER_EMPLOYMENT_STATUS',
  HUBLER_EMPLOYMENT_STATUS_INCOMPATIBLE_WITH_PRICING_PLAN = 'HUBLER_EMPLOYMENT_STATUS_INCOMPATIBLE_WITH_PRICING_PLAN',
  ASSIGNMENT = 'ASSIGNMENT',
  REGISTRATION_NUMBER = 'REGISTRATION_NUMBER',
  JOBS = 'JOBS',
  SPECIALTIES = 'SPECIALTIES',
  CHARTER = 'CHARTER',
  PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
  DOCUMENTS = 'DOCUMENTS',
  NOTIFICATIONS = 'NOTIFICATIONS',
  COMPLETE = 'COMPLETE',
  MISSING_DOCUMENTS = 'MISSING_DOCUMENTS',
  SENT = 'SENT',
}
